import { useCallback, useEffect, useState } from 'react'

import {
  verifyShouldDisplayBanner, verifyShouldDisplayBannerWithCashback, loadBannerData, BannerData
} from './BannerBehaviour'
import BannerComponent from './BannerComponent'

const BannerContainer = () => {
  const [BannerData, setBannerData] = useState({
    dateStartPromotion: '',
    isOnMobileApp: false,
    displayComponent: false,
    environment: '',
    textFirstLineBanner: '',
    textSecondLineBanner: '',
    textButtonBanner: '',
    linkButtonBanner: ''
  })

  const verifyShouldDisplay = useCallback(async () => {
    const data: BannerData | undefined = await loadBannerData()

    setBannerData({
      dateStartPromotion: data?.dateStartPromotion || '',
      isOnMobileApp: data?.isOnMobileApp || false,
      displayComponent: data?.dateStartPromotion
        ? verifyShouldDisplayBannerWithCashback(data) : verifyShouldDisplayBanner(data),
      environment: data?.environment || '',
      textFirstLineBanner: data?.textFirstLineBanner || '',
      textSecondLineBanner: data?.textSecondLineBanner || '',
      textButtonBanner: data?.textButtonBanner || '',
      linkButtonBanner: data?.linkButtonBanner || ''
    })
  }, [])

  useEffect(() => {
    verifyShouldDisplay()
  }, [verifyShouldDisplay])

  return (
    <BannerComponent
      displayComponent={BannerData.displayComponent}
      datePromotion={BannerData.dateStartPromotion}
      isOnMobileApp={BannerData.isOnMobileApp}
      environment={BannerData.environment}
      textFirstLine={BannerData.textFirstLineBanner}
      textSecondLine={BannerData.textSecondLineBanner}
      textButton={BannerData.textButtonBanner}
      linkButton={BannerData.linkButtonBanner}
    />
  )
}

export default BannerContainer
